"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScoreSet = void 0;
const ModelCommon_1 = require("../ModelCommon");
const typeName = 'ScoreSet';
/** @deprecated in favour of `ScoreConfig` */
class ScoreSet extends ModelCommon_1.ModelCommon {
    constructor(vob) {
        super(typeName, vob ?? {});
        this.name = vob?.name ?? typeName;
        this.supportedType = vob?.supportedType ?? '';
        this.raw = JSON.parse(JSON.stringify(vob?.raw ?? []));
        this.composite = JSON.parse(JSON.stringify(vob?.composite ?? []));
    }
}
exports.ScoreSet = ScoreSet;
